module.exports = __webpack_public_path__ + "media/application/images/svgs/plus-9b08278346507cef320f9f9556af5c09.svg";